var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-fade-in"}},[(_vm.show)?_c('div',{staticClass:"page_content p_flex p_justify_center p_align_items",on:{"scroll":function($event){$event.preventDefault();},"touchmove":function($event){$event.preventDefault();},"click":_vm.click_close}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72b9f50f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public-popup/public-popup.vue
// module id = 4TE3
// module chunks = 11